module.exports = __webpack_public_path__ + "img/Background.16c942da.svg";